import { render, staticRenderFns } from "./model-train.vue?vue&type=template&id=62cd423b&"
import script from "./model-train.vue?vue&type=script&lang=ts&"
export * from "./model-train.vue?vue&type=script&lang=ts&"
import style0 from "./model-train.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports